<script>
import { computed } from '@vue/runtime-core';
import { useStore } from 'vuex';
export default {
  setup(){
    const store  = useStore();
    const data = computed(()=> store.getters.equipment);

    return {data};
  }
}
</script>

<template>
<div class="main">
  <div class="equipment" v-for="item in data" :key="item.name">
       <img :src=item.picture :alt=item.name class="img">
       <h2 class="introduction">{{item.name}}</h2>
  </div>
</div>
 
</template>

<style lang="scss" scoped>
.main{
  display:flex;
  flex-wrap: wrap;
  margin-left: 20%;
  margin-right: 20%;
  div:nth-child(4n-3){background-color: #007acc;}
  div:nth-child(4n-2){background-color: #014c8f;}
  div:nth-child(4n-1){background-color: #29A0AD;}
  div:nth-child(4n){background-color: #FF667F;}
  >.equipment{
    width: 30%;
    padding: 3%;
    text-align: center;
    margin: 3% 1% 1% 1%;
    border-radius: 15px;
    >.introduction{
      color: #fff;
      margin-top: 3%;
    }
    >.img{
      width: 90%;
    }
  }
}


</style>